import React, { useCallback, useMemo, useState } from 'react';
import {
  Tabs,
  Tab,
  Slide,
  Box,
  Button,
  Divider,
} from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { useParams } from 'react-router-dom';
import { useGetOne } from 'react-admin';

import Entities from './Entities';

import entityTypes from '../../../../../constants/entityTypes';
import PartyForm from './forms';
import useDialogStatus from '../../../../../hooks/useDialogStatus';
import { ValueOf } from '../../../../../utilities/types';
import { ICase } from '../../../../../utilities/schemas/case';

const tabNames = {
  ALL_INDIVIDUALS: 'all-individuals',
  CASE_INDIVIDUALS: 'case-individuals',
  ALL_BUSINESSES: 'all-businesses',
  CASE_BUSINESSES: 'case-businesses',
} as const;
type TabNames = ValueOf<typeof tabNames>;

const Create = () => {
  const { open, openDialog, closeDialog } = useDialogStatus();
  const [value, setValue] = useState<TabNames>(tabNames.CASE_INDIVIDUALS);

  const { caseId } = useParams();
  const { data } = useGetOne<ICase>('cases', { id: caseId! }, { enabled: !!caseId });

  const handleChangeTab = useCallback((_event: React.SyntheticEvent, newValue: TabNames) => {
    setValue(newValue);
  }, []);

  const entityType = ([
    tabNames.ALL_BUSINESSES,
    tabNames.CASE_BUSINESSES,
  ] as TabNames[]).includes(value) ? entityTypes.BUSINESS : entityTypes.INDIVIDUAL;

  const caseEntityIds = useMemo(() => data?.entities
    .map((entity) => entity.id), [data?.entities]);

  return (
    <>
      <Slide direction="right" in={!open} appear={false}>
        <Box display={open ? 'none' : 'block'}>
          <Tabs value={value} onChange={handleChangeTab}>
            <Tab value={tabNames.CASE_INDIVIDUALS} label="Case individuals" />
            <Tab value={tabNames.CASE_BUSINESSES} label="Case businesses" />
            <Tab value={tabNames.ALL_INDIVIDUALS} label="All individuals" />
            <Tab value={tabNames.ALL_BUSINESSES} label="All businesses" />
          </Tabs>
          <Divider />
          <Box marginTop={4}>
            {value === tabNames.CASE_INDIVIDUALS && (
              <Entities
                type={entityType}
                handleOpenChange={openDialog}
                entities={caseEntityIds}
              />
            )}
            {value === tabNames.CASE_BUSINESSES && (
              <Entities
                type={entityType}
                handleOpenChange={openDialog}
                entities={caseEntityIds}
              />
            )}
            {value === tabNames.ALL_INDIVIDUALS && (
              <Entities
                type={entityType}
                handleOpenChange={openDialog}
              />
            )}
            {value === tabNames.ALL_BUSINESSES && (
              <Entities
                type={entityType}
                handleOpenChange={openDialog}
              />
            )}
          </Box>
        </Box>
      </Slide>
      <Slide direction="left" in={open}>
        <Box display={!open ? 'none' : 'block'}>
          <Box marginBottom={4}>
            <Button startIcon={<ArrowBackIosNewIcon />} onClick={closeDialog}>
              Back
            </Button>
          </Box>
          <PartyForm type={entityType} />
        </Box>
      </Slide>
    </>
  );
};

export default Create;
